import React from "react"

const SaleLedgerActiveIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
            <path d="M18.5 15.9286V9C18.5 5.22876 18.5 3.34315 17.3284 2.17157C16.1569 1 14.2712 1 10.5 1H9.5C5.72876 1 3.84315 1 2.67157 2.17157C1.5 3.34315 1.5 5.22876 1.5 9V18.5" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" />
            <path d="M18.5 16H4C2.61929 16 1.5 17.1193 1.5 18.5C1.5 19.8807 2.61929 21 4 21H18.5" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" />
            <path d="M7 9.32653L8.40901 10.8131C9.15901 11.6044 9.53401 12 10 12C10.466 12 10.841 11.6044 11.591 10.8131L13 9.32653M10 11.9128L10 5" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18.5 16C17.1193 16 16 17.1193 16 18.5C16 19.8807 17.1193 21 18.5 21" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" />
        </svg>
    )
}
export default SaleLedgerActiveIcon